import React, { useEffect, useRef, useState } from "react";
import PortfolioFooterTable from "../PFGridComponents/PortfolioFooterTable";
import { calculateLatestPFValues } from "@portfolio/utils/PFService";

const PortfolioTotalsProvider = ({ aggregatedStocks, pfQuotes }) => {
    const [totals, setTotals] = useState({
        totalAmountInvested: "0.00",
        totalTodayGain: "0.00",
        totalTodayGainPercentage: "0.00",
        totalOverallGain: "0.00",
        totalOverallGainPercentage: "0.00",
        totalCurrentValue: "0.00"
    });

    const stocksRef = useRef(aggregatedStocks);

    useEffect(() => {
        stocksRef.current = aggregatedStocks;

        // ✅ Calculate immediately when stocks change (e.g., tab click)
        if (aggregatedStocks?.length > 0) {
            const immediateTotals = calculateTotals(aggregatedStocks, pfQuotes);
            setTotals(immediateTotals);
        }
    }, [aggregatedStocks, pfQuotes]);

    useEffect(() => {
        const interval = setInterval(() => {
            const latest = stocksRef.current;
            if (!latest || !Array.isArray(latest) || latest.length === 0) return;

            setTotals(calculateTotals(latest, pfQuotes));
        }, 10000);

        return () => clearInterval(interval);
    }, [pfQuotes]);

    const calculateTotals = (incomingStocks, pfQuotes) => {
        let totalAmountInvested = 0;
        let totalTodayGain = 0;
        let totalOverallGain = 0;
        let totalCurrentValue = 0;

        incomingStocks.forEach(stock => {
            const values = calculateLatestPFValues(stock, pfQuotes);
            if (!values) return;

            const {
                todayGain,
                todayGainPerc,
                overallGain,
                currentValue
            } = values;

            totalAmountInvested += stock.amountInvested || 0;
            totalTodayGain += todayGain || 0;
            totalOverallGain += overallGain || 0;
            totalCurrentValue += currentValue || 0;
        });

        return {
            totalAmountInvested: totalAmountInvested.toFixed(2),
            totalTodayGain: totalTodayGain.toFixed(2),
            totalTodayGainPercentage: totalAmountInvested > 0 ? ((totalTodayGain / totalAmountInvested) * 100).toFixed(2) : "0.00",
            totalOverallGain: totalOverallGain.toFixed(2),
            totalOverallGainPercentage: totalAmountInvested > 0 ? ((totalOverallGain / totalAmountInvested) * 100).toFixed(2) : "0.00",
            totalCurrentValue: totalCurrentValue.toFixed(2)
        };
    };

    return <PortfolioFooterTable totals={totals} />;
};

export default PortfolioTotalsProvider;
